module.exports = __webpack_public_path__ + "static/media/Initialloading.4e1b1a48.gif";